const SpyXFamily = {
    id: 5,
    title: "Spy x Family: A Unique Blend of Espionage and Comedy",
    postTitleImage: require("../BlogAssets/images/SpyXFamily/roger-spy.webp"),
    date: "November 20, 2023",
    sections: [
      {
        heading: "Meet the Forgers",
        content:
          `Some anime have a way of pulling you in from the start, and Spy x Family does it
           perfectly. You’re introduced to the Forgers a fake family brought together for
            a secret mission. Loid is a spy, Yor is an assassin, and Anya, their adopted
             daughter, can read minds, somehow, it works so effortlessly, Loid’s struggle to balance his job with pretending to be a normal
              father it all comes together in a way that’s both heartwarming and entertaining....`,
      },
      {
        preHeadingImages: [
          require("../BlogAssets/images/SpyXFamily/lovexspy.webp"),
          require("../BlogAssets/images/SpyXFamily/Spy-x-kids1.avif"),
        ],
        heading: "Why It's a Must-Watch",
        content:
          `From Loid's thrilling spy missions to Anya's adorable attempts at helping, 
          Spy x Family strikes a perfect balance between action and comedy....`,
      },
      {
        heading: "",
        content:
          `Despite being a fake family, the bonds they form feel genuine, making you laugh, 
         and will make you laugh...`,
      },
    ],
    tags: ["Anime", "Comedy", "Espionage"],
    images: [
      require("../BlogAssets/images/SpyXFamily/roger-spy.webp"),
      require("../BlogAssets/images/SpyXFamily/Millie_and_Camilla.webp"),
      require("../BlogAssets/images/SpyXFamily/Spy-xschool.jpg"),
    ],
  };
  
  export default SpyXFamily;
  